import React from 'react';
import { Heart } from 'lucide-react';
function InstagramIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-142">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-143" />
    </svg>;
}
function FacebookIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-144">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.737-.9 10.125-5.864 10.125-11.854z" data-id="element-145" />
    </svg>;
}
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-146">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-147" />
    </svg>;
}
function YouTubeIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-148">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-149" />
    </svg>;
}
export function Footer() {
  return <footer className="bg-deep-brown text-cream/80 py-12 px-6" data-id="element-150">
      <div className="max-w-6xl mx-auto flex flex-col gap-8" data-id="element-151">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-152">
          <div className="text-center md:text-left" data-id="element-153">
            <h3 className="text-2xl font-playfair text-amber mb-2" data-id="element-154">
              Rompiendo el Silencio
            </h3>
            <p className="text-sm" data-id="element-155">Un espacio seguro para sanar.</p>
          </div>

          <div className="flex items-center gap-4" data-id="element-156">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center text-cream/70 hover:bg-terracotta hover:text-white transition-colors duration-300" aria-label="Instagram" data-id="element-157">
              <InstagramIcon className="w-5 h-5" data-id="element-158" />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center text-cream/70 hover:bg-terracotta hover:text-white transition-colors duration-300" aria-label="Facebook" data-id="element-159">
              <FacebookIcon className="w-5 h-5" data-id="element-160" />
            </a>
            <a href="https://www.tiktok.com/@garciadanielakl?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center text-cream/70 hover:bg-terracotta hover:text-white transition-colors duration-300" aria-label="TikTok" data-id="element-161">
              <TikTokIcon className="w-5 h-5" data-id="element-162" />
            </a>
            <a href="https://youtube.com/@danielagarciakl?si=bie0k9eRQpWN-0w0" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center text-cream/70 hover:bg-terracotta hover:text-white transition-colors duration-300" aria-label="YouTube" data-id="element-163">
              <YouTubeIcon className="w-5 h-5" data-id="element-164" />
            </a>
          </div>

          <div className="text-center md:text-right text-sm" data-id="element-165">
            <p data-id="element-166">© 2026 Daniela Garcia Lantigua.</p>
            <p data-id="element-167">Todos los derechos reservados.</p>
          </div>
        </div>

        <div className="border-t border-cream/10 pt-6 flex justify-center" data-id="element-168">
          <div className="flex items-center space-x-2 text-sm" data-id="element-169">
            <span data-id="element-170">Hecho con</span>
            <Heart className="w-4 h-4 text-terracotta fill-terracotta" data-id="element-171" />
            <span data-id="element-172">para sobrevivientes</span>
          </div>
        </div>
      </div>
    </footer>;
}